module.exports = __webpack_public_path__ + "img/ef4bd84.png";